import { _ as slot } from "../../../chunks/index.js";
function _layout($$payload, $$props) {
  $$payload.out += `<!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!---->`;
}
export {
  _layout as default
};
